<div class="branches-list">
  <form class="branches-list__container" [formGroup]="branchesForm">
    <div
      *ngIf="isLoading; else branchesList"
      [mmTestTarget]="'branches-spinner'"
      class="branches-list__spinner-wrapper"
    >
      <mm-spinner diameter="50"></mm-spinner>
    </div>

    <ng-template #branchesList>
      <div class="branches-list__info-text">
        {{ 'PAGES.AUTH.REGISTRATION.BRANCH_SELECTION.INFO_TEXT' | translate }}
      </div>
      <div [class.branches-list__wrapper]="isNewBranchSelectionDesignEnabled$ | async">
        <ng-template ngFor let-branch [ngForOf]="branches" let-isFirst="first" let-isLast="last">
          <label
            class="radio-item"
            [class.first]="isFirst"
            [class.last]="isLast && !(isNewBranchSelectionDesignEnabled$ | async)"
            [class.selected-branch]="
              branchesForm.value.selectedBranch === branch?.metaData.branchNumber &&
              (isNewBranchSelectionDesignEnabled$ | async)
            "
            [for]="'mm-radio-' + branch?.metaData.branchNumber"
            [class.newDesign]="isNewBranchSelectionDesignEnabled$ | async"
          >
            <div class="radio-item__radio-wrapper">
              <mm-radio
                formControlName="selectedBranch"
                [id]="branch?.metaData.branchNumber"
                [value]="branch?.metaData.branchNumber"
              ></mm-radio>
            </div>
            <div class="radio-item__text-wrapper">
              <h4 class="radio-item__title">{{ branch?.company?.companyName }}</h4>
              <p *ngIf="branch?.metaData?.branchNumber" class="radio-item__description">
                {{ 'PAGES.AUTH.REGISTRATION.BRANCH_SELECTION.BRANCH_NUMBER' | translate }}:
                {{ replaceBranchNumberUnderscore(branch?.metaData?.branchNumber) }}
              </p>
              <p *ngIf="!branch?.metaData?.rsin && !isFrenchMarket" class="radio-item__description">
                {{ 'PAGES.AUTH.REGISTRATION.BRANCH_SELECTION.RSIN' | translate }}: {{ branch?.metaData?.rsin }}
              </p>
              <p class="radio-item__description">
                {{ replacePinCode(branch?.company?.fullAddress, branch?.company?.postalCode) }}
              </p>
              <p class="radio-item__description">
                {{ branch?.company?.postalCode }}, {{ currentCountryCode }}
              </p>
            </div>
          </label>
        </ng-template>
      </div>
    </ng-template>

    <div
      class="branches-list__actions"
      [ngClass]="{
        'blur-effect': branches.length > number2 && (isNewBranchSelectionDesignEnabled$ | async)
      }"
    >
      <button
        class="branches-list__action"
        type="submit"
        mm-button
        fluid="true"
        test-target="branches-list-form__submit"
        [disabled]="branchesForm.invalid"
        [loading]="isLoading"
        (click)="goToTierTwoSignup()"
      >
        <div class="button-container">
          <div>{{ 'REGULAR.CONTINUE' | translate }}</div>
        </div>
      </button>
    </div>
  </form>
</div>
